import {fetchRouteContent} from "../../stageStatus/network/StageNetworkAPI";

export const CartDetailReducer = (state, action) => {
    switch(action.type) {
        case "LOAD_VIEW":
            const {routeId, cartId, dispatcher, baseUrl, stationCode, stationConfig} = action.data;
            fetchRouteContent(routeId, cartId, dispatcher, baseUrl, stationCode, stationConfig)
            return state
        case "UNLOAD_VIEW":
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data}
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/cartDrillDown/reducer/CartDetailReducer.js